import {
  IconAddressBook,
  IconBolt,
  IconBooks,
  IconBoxSeam,
  IconCalculator,
  IconCalendarCode,
  IconCar,
  IconCheck,
  IconChecklist,
  IconClock,
  IconCoinEuro,
  IconCoinPound,
  IconConfetti,
  IconFileTypePdf,
  IconListCheck,
  IconMail,
  IconMan,
  IconMapPin,
  IconMessage,
  IconPencil,
  IconPlaneTilt,
  IconPlus,
  IconPrison,
  IconSchool,
  IconSteeringWheel,
  IconTruck,
  IconUser,
  IconX,
  IconZoomQuestion,
  IconProps as TablerIconProps,
} from '@tabler/icons-react';
import { ExoticComponent } from 'react';
import {
  CalendarIllustration,
  CarIllustration,
  ClockIllustration,
  FormIllustration,
  IconProps,
  LearnerIllustration,
  LifeBuoyIllustration,
  MedicalBagIllustration,
  MoneyBagIllustration,
  PhoneIllustration,
  SaleTagIllustration,
  StarIllustration,
  ThumbsUpIllustration,
  UmbrellaIllustration,
} from './illustration';
import { PaperIcon } from '@/components/global/Header/icons';

const illustrationSet: Record<string, ExoticComponent<TablerIconProps> | React.FC<IconProps>> = {
  Car2: CarIllustration,
  FastClock: ClockIllustration,
  Form: FormIllustration,
  LifeBuoy: LifeBuoyIllustration,
  MoneyBag: MoneyBagIllustration,
  Phone: PhoneIllustration,
  Star: StarIllustration,
  ThumbsUp: ThumbsUpIllustration,
  Uberella: UmbrellaIllustration,
  SaleTag: SaleTagIllustration,
  MedicalBag: MedicalBagIllustration,
  Calendar: CalendarIllustration,
};

export const iconSet: Record<string, ExoticComponent<TablerIconProps> | React.FC<IconProps>> = {
  AddressBook: IconAddressBook,
  Bolt: IconBolt,
  Books: IconBooks,
  BoxSeam: IconBoxSeam,
  Calculator: IconCalculator,
  CalendarCode: IconCalendarCode,
  Car: IconCar,
  Check: IconCheck,
  Checklist: IconChecklist,
  Clock: IconClock,
  CoinEuro: IconCoinEuro,
  CoinPound: IconCoinPound,
  Confetti: IconConfetti,
  Letter: IconMail,
  ListCheck: IconListCheck,
  MagnifierQuestion: IconZoomQuestion,
  Man: IconMan,
  MapPin: IconMapPin,
  PDF: IconFileTypePdf,
  Pencil: IconPencil,
  PlaneTilt: IconPlaneTilt,
  Plus: IconPlus,
  Prison: IconPrison,
  SchoolHat: IconSchool,
  SpeechBubble: IconMessage,
  SteeringWheel: IconSteeringWheel,
  User: IconUser,
  Van: IconTruck,
  X: IconX,
  Guide: PaperIcon,
  Learner: LearnerIllustration,
  ...illustrationSet,
};

// All illustration icons should not have a background.
export const iconsWithoutBackground = [...Object.keys(illustrationSet)];
